export default x => x === undefined || x === null;
